import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const getAllAirportLocationType = createAsyncThunk(
  'airportLocationType/getAllAirportLocationType',
  async ({ limit = 10, page = 1 }, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`/airport-location-types?page=${page}&limit=${limit}`);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const getDetailAirportLocationType = createAsyncThunk(
  'airportLocationType/getDetailAirportLocationType',
  async (id, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`/airport-location-types/${id}`);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const createAirportLocationType = createAsyncThunk(
  'airportLocationType/createAirportLocationType',
  async (payload, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        `/airport-location-types`,
        { ...payload },
        {
          headers: {
            'Content-Type': 'application/json;charset=utf-8',
          },
        },
      );

      const data = await response.data;
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const updateAirportLocationType = createAsyncThunk(
  'airportLocationType/updateAirportLocationType',
  async (payload, thunkAPI) => {
    const { payloadData, airportLocationTypeId } = payload;

    try {
      const response = await axiosInstance.put(
        `/airport-location-types/${airportLocationTypeId}`,
        { ...payloadData },
        {
          headers: {
            'Content-Type': 'application/json;charset=utf-8',
          },
        },
      );

      const data = await response.data;
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const deleteAirportLocationtype = createAsyncThunk(
  'airportLocationType/deleteAirportLocationtype',
  async (id, thunkAPI) => {
    try {
      const response = await axiosInstance.delete(`/airport-location-types/${id}`);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);
